export default __webpack_public_path__ + "static/media/headerImg.00d05f03.png";